import { Component } from '@angular/core';
import { OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../services/user.service';
import { AboutComponent } from '../../components/about/about.component';
import { CookiesComponent } from '../../components/cookies/cookies.component';

/**
 * App footer component.
 */
@Component({
	selector: 'kv-footer',
	templateUrl: './footer.component.html',
	styleUrl: './footer.component.css'
})
export class FooterComponent implements OnInit, OnDestroy {

	private userEventSubscription!: Subscription;

	LOCALIZATION: any;

	cookieClosed: boolean = false;
	cookieEmoji = '\u{1F36A}'; 

	constructor(
		private ngbModal: NgbModal,
		private userService: UserService
	) {
		this.LOCALIZATION = this.userService.LOCALIZATION;
	 }

	ngOnInit(): void {
		this.userEventSubscription = this.userService.broadcastEvent.subscribe((event: string) => {
			if (event === 'loggedin') {
				this.updateCookieState();
			}
			if (event === 'localizationLoaded') {
				this.LOCALIZATION = this.userService.LOCALIZATION;
			}			
		});

		this.cookieClosed = sessionStorage.getItem("cookiesAllowed") === "true";
	}
	
	ngOnDestroy() {
		if (this.userEventSubscription) {
			this.userEventSubscription.unsubscribe();
		}
	}	

	private updateCookieState(): void {
		let userData = this.userService.getLocalStorageData();
		this.cookieClosed = this.cookieClosed || userData.cookieClosed;
		if (this.cookieClosed) {
			userData.cookieClosed = true;
			userData.gaCookieAllowed = true;
			this.userService.setLocalStorageData(userData);
		}
	}

	/**
	 * Displays the About modal.
	 */
	about(event?: Event): void {
		if (event) event.preventDefault();
		
		const modalRef = this.ngbModal.open(AboutComponent);

		modalRef.result.then(
			(payload) => {
				console.log('Modal dismissed');
			},
			(reason) => {
				console.log('Modal dismissed');
			}
		);
	}

	/**
	 * Displays the Cookies modal.
	 */
	manageCookies(event?: Event): void {
		if (event) event.preventDefault();
		
		const modalRef = this.ngbModal.open(CookiesComponent);

		modalRef.result.then(
			(result) => {
				if (result.result?.answer === 'ok') {
					this.cookieClosed = true;
				}
			},
			(reason) => {
				console.log('Modal dismissed');
			}
		);
	}

	/**
	 * Convenience option allowing user to quickly accept all cookies.
	 */
	acceptCookies(): void {
		sessionStorage.setItem("cookiesAllowed", "true");

		let userData = this.userService.getLocalStorageData();
		userData.cookieClosed = true;
		userData.gaCookieAllowed = true;
		this.userService.setLocalStorageData(userData);
		
		this.cookieClosed = true;
	}
}
